import { useState, useEffect } from "react";
import api from "../../../utils/api";
import { IconX } from "../../../utils/Icons";
import { initials } from "../../../utils/chatFormatters";

/* ── User Picker Modal ───────────────────────────────────────────────────────── */
function UserPicker({ onSelect, onClose }) {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/users")
      .then(({ data }) => setUsers(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = users.filter(
    (u) =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div
      className="achat-picker-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="achat-picker">
        <div className="achat-picker-header">
          <span className="achat-picker-title">Start a Conversation</span>
          <button className="achat-picker-close" onClick={onClose}>
            <IconX />
          </button>
        </div>
        <div className="achat-picker-search-wrap">
          <input
            className="achat-picker-search"
            placeholder="Search users by name or email…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>
        <div className="achat-picker-list">
          {loading ? (
            <div className="achat-picker-empty">Loading users…</div>
          ) : filtered.length === 0 ? (
            <div className="achat-picker-empty">No users found.</div>
          ) : (
            filtered.map((u) => (
              <div
                key={u._id}
                className="achat-picker-item"
                onClick={() => onSelect(u)}
              >
                <div className="achat-picker-av">
                  {initials(u.name || u.email)}
                </div>
                <div>
                  <div className="achat-picker-name">{u.name || "—"}</div>
                  <div className="achat-picker-email">{u.email}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
export default UserPicker;
